"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useRootPortal_1 = require("../_utils/useRootPortal");
var useConfigurableStyle_1 = require("../_utils/useConfigurableStyle");
var hooks_1 = require("../../hooks");
var corejs_1 = require("@mesacloud/corejs");
var MouseTooltip = function (_a) {
    var startingPosition = _a.startingPosition, className = _a.className, overrideDefaultClassName = _a.overrideDefaultClassName, children = _a.children, props = __rest(_a, ["startingPosition", "className", "overrideDefaultClassName", "children"]);
    var tooltipRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (tooltipRef && tooltipRef.current) {
            if (startingPosition && startingPosition.length === 2) {
                tooltipRef.current.style.left = startingPosition[0] + 5 + "px";
                tooltipRef.current.style.top = startingPosition[1] + 5 + "px";
            }
        }
    }, []);
    hooks_1.useWindowListener('mousemove', corejs_1.debounce(function (_a) {
        var clientX = _a.clientX, clientY = _a.clientY;
        if (tooltipRef && tooltipRef.current) {
            tooltipRef.current.style.left = clientX + 5 + "px";
            tooltipRef.current.style.top = clientY + 5 + "px";
        }
    }));
    var finalClassName = useConfigurableStyle_1.useConfigurableStyle({
        defaultClassName: "mouse-tooltip",
        additionalClassName: className,
        overrideDefaultClassName: overrideDefaultClassName,
    })[0];
    return useRootPortal_1.useRootPortal((react_1.default.createElement("div", __assign({ ref: tooltipRef, className: finalClassName }, props), children)), "tooltip-root");
};
exports.default = MouseTooltip;
